import Movies from "../Movies/movies";

function Favourites(props) {
  return (
    <Movies showFavourites={true} />
  );
}


export default Favourites;